import React from "react";

import Button from '@material-ui/core/Button';
import WarningIcon from '@material-ui/icons/Warning';

export const ThresholdButton = (props) => {
	return <Button startIcon={<WarningIcon />} {...props}>Soglie</Button>;
}